import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MonitorProcessosService {

  monitorProcessos$ = new BehaviorSubject(null);
  monitorProcessosPaginado$ = new BehaviorSubject(null);
  eventoFeitoConferido$ = new BehaviorSubject(null);
  reenviarEmail$ = new BehaviorSubject(null);
  historicoPoderCliente$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  getMonitorProcessos() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/DashboardCached/" + environment.empresa + "/0";
      
      this.http.get(url).subscribe({
        next: (data) => this.monitorProcessos$.next(data),
        error: (error: HttpErrorResponse) => {
          this.monitorProcessos$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.monitorProcessos$.unsubscribe(),
          this.monitorProcessos$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }


  //   getMonitorProcessosPaginado(currentPage, totalPorPagina) {
  //     try {
  //       // var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/dashboard_de_processos/" + environment.empresa + "/"+ currentPage + "/" + totalPorPagina;

  // var url = "http://devapp.advicetech.com.br/Advice.FP.Rest/api/v1.0/Dashboard/dashboard_de_processos_paginados/STONEX/" + currentPage + "/" + totalPorPagina;

  //       this.http.get(url).subscribe({
  //         next: (data) => this.monitorProcessosPaginado$.next(data),
  //         error: (error: HttpErrorResponse) => {
  //           this.monitorProcessosPaginado$.next(false);
  //           if (error.status === 500) {
  //             Swal.fire({
  //               'width': 500,
  //               'title': 'Oops...',
  //               'text': error.error.detail,
  //               'icon': 'error'
  //             });
  //           } else {
  //             Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
  //           }
  //         }
  //       }).add(() => {
  //         this.monitorProcessosPaginado$.unsubscribe(),
  //           this.monitorProcessosPaginado$ = new BehaviorSubject(null);
  //       });
  //     } catch (e) {
  //       Swal.fire({
  //         title: "Oops...",
  //         text: "Algo deu errado, por favor entre em contato com o Suporte!",
  //         icon: "error",
  //         timer: 1500,
  //         showCancelButton: false,
  //         showConfirmButton: true
  //       });
  //     }
  //   }

  getMonitorProcessosPaginado(busca: any) {
    try {
      // var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/dashboard_de_processos/" + environment.empresa + "/"+ currentPage + "/" + totalPorPagina;
      
    busca.empresa = environment.empresa;
    var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/dashboard_de_processos_paginados";
      // busca.empresa = "STONEX";
      // busca.empresa= environment.empresa;
      // var url = "http://devapp.advicetech.com.br/Advice.FP.Rest/api/v1.0/Dashboard/dashboard_de_processos_paginados";
      
      
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      this.http.post(url, busca, { headers: headers }).pipe(
        debounceTime(1500)).subscribe({
          next: (res: any) => this.monitorProcessosPaginado$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.monitorProcessosPaginado$.unsubscribe(),
            this.monitorProcessosPaginado$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }


  eventoFeitoConferidoPost(evento: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/FeitoConferido/Incluir"
      evento.empresa = environment.empresa;
      evento.cd_usuario_solicita = environment.cd_usuario;

      this.http.post(url, evento, { headers: headers })
        .subscribe({
          next: (res: any) => this.eventoFeitoConferido$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.eventoFeitoConferido$.unsubscribe(),
            this.eventoFeitoConferido$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  reenviarEmail(id_poder_cliente) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/ReenviaEmail"
      var obj: any = new Object();
      obj.empresa = environment.empresa;
      obj.id_poder_cliente = id_poder_cliente;
      obj.id_autorizador_interno = environment.id_autorizador;

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.reenviarEmail$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.reenviarEmail$.unsubscribe(),
            this.reenviarEmail$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  getHistoricoPoderCliente(id_poder_cliente) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/ObterHistoricoPoderCliente/" + environment.empresa + "/" + id_poder_cliente;
      
      this.http.get(url, { headers: headers })
        .subscribe({
          next: (res: any) => this.historicoPoderCliente$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.historicoPoderCliente$.unsubscribe(),
            this.historicoPoderCliente$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

}

